import React from "react"
import { useDispatch } from "react-redux";
import Container from '@material-ui/core/Container'
import AppBarFlex from './appBarLandingPage'
import CssBaseline from '@material-ui/core/CssBaseline';
import {ThemeProvider} from '@material-ui/core/styles'
import RBTheme from '../components/reedBasketTheme'
import { Provider } from 'react-redux'
import actionSetMessagesByLanguage  from '../state/actionSetImportantMessageByLanguage'
import './i18n';
import { withTranslation  } from 'react-i18next';
import messagesIT from '../state/importantMessages.it'
import messagesEN from '../state/importantMessages.en'
import createStore from '../state/store'
import { makeStyles } from '@material-ui/core/styles';




const useStyles = makeStyles(theme => ({
sectionDesktop: {
    position: "fixed",
    margin: "0 auto",
    width: "100%",
    top: '0px',
    zIndex:"2",       
    display: 'flex',
},
 

  children:{
        marginTop: "70px",
        
  }
 
}))

function Layout(props){
    let classes = useStyles();

    const dispatch = useDispatch();
    React.useEffect(()=>{
       
       
        switch (props.i18n.language) {
          case "en-GB":
             dispatch(actionSetMessagesByLanguage(messagesEN));
              break;
          case "it":
            dispatch(actionSetMessagesByLanguage(messagesIT));
        };
      
       
    })

    const store = createStore();
    return (
        <ThemeProvider theme={RBTheme}>
        <CssBaseline/>
        <Provider store={store}>
        <Container  disableGutters={true} >
            <div className={classes.sectionDesktop}>
                <AppBarFlex/>
            </div>
          
               
                <Container >
                    {props.children}
                </Container>
        </Container>
        </Provider>
        </ThemeProvider>
    
    )
}

export default withTranslation('strings') (Layout)